<template>
  <!-- <fade-transition :duration="1000" v-show="show"> -->
  <v-container
    fluid
    grid-list-lg
    text-xs-center
    class
    style="height:100%;background-image: linear-gradient(-225deg, #69EACB 0%, #EACCF8 48%, #6654F1 100%);"
  >
    <v-layout row wrap align-center justify-center fill-height>
      <particles></particles>

      <v-flex xs12>
        <v-card dark style="color: #555; background-color:rgba(255,255,255, 0.5);">
          <v-card-text style="text-align: left;">
            <h1 style="text-align: center;">Data Protection and Privacy</h1><br><br>

            <p>Welcome to the "Agecheck" app, which is operated by PrivatelySA Switzerland, based at EPFL Innovation Park, Lausanne, 1015, Switzerland (collectively referred to as "Privately 'we", "us" or "our").</p>
            
            <p>We develop a number of privacy preserving technologies connected with online safety and age estimation to keep minors safe online. This new app, the "Agecheck", is a test appplication for potential clients to test our multimodal age classification which is based on face and image pattern analysis. </p>
            
            <p>The "Agecheck app" uses the latest advances in the field of artificial intelligence to automatically estimate age of the user on the basis of either facial images , voice or a combination of both. The entire processing happens on the user's device and hence no user data leaves the user device for the purpose of this age estimation.
            
            <p>This is a privacy preserving implementation of age estimation technology.</p>
            
            <p>This privacy policy explains how we collect, use, share and protect this information in relation to the Service.</p>

            <br><h2>1. Our collection and use of personal information</h2><br>

            <p>As with most online services, personal information is required to set up your account and use our service. We only collect personal information that is required to meet the needs of the offer or as aggregated statistics to improve our services.
            We currently collect the following personal information provided by users:</p>

            <ul><li>Your email address</li></ul><br>

            <h3>Analysis information</h3>
            
            <p>We may use third party tools (Google Analytics, Mixpanel and Fabric) to analyze the traffic generated by the service, the number of users and similar statistical metrics.</p>
            
            <h3>Metadata</h3>
            
            <p>We store metadata, i.e. all technical data that are necessary for the proper operation of the service, such as web server logs, application logs, browser statistics, usage statistics, etc.</p>
            
            <p>By using the offer, you give your express consent to the collection, treatment, including but not limited to the retention and storage of your personal data (Section 1), and your communication as required for the functioning of this application, and their transfer to relevant third parties who are involved with to carry out the processing or the provision of services, in accordance with this data protection guideline and the terms of use of the service.</p>

            <br><h2>2. Disclosure of the information we collect</h2><br>

            <p>This app does not collect any personally identifiable information or and biometric information about the user beyond the email address. 
            The analyzed content never leaves the user's phone and is not accessible by, nor ever shared with anyone including us.</p>

            <br><h2>3. How we store your information</h2><br>

            <p>The user information collected by the service is stored and processed in Switzerland and the European Union.</p>
            
            <p>Privately SA undertakes to treat all personal data of its users in accordance with the general EU data protection regulation and the Swiss federal law on data protection. We currently rely on some non-EU web services (Google, Mixpanel, Twitter, Mailjet and UrbanAirship) which may also have access to some of the users information.</p>
            
            <p>We will retain your email as long as you are using the service and will delete your email from our records within 30 days of being notified about app deletion.</p>
            
            <br><h2>4. Other websites and services</h2><br>
            
            <p>We are not responsible for the practices of websites or services that are linked to our offer, including the information or content contained therein. Please remember that if you go from our offer to another website or service, our privacy policy does not apply to these websites or third-party services. Your browsing and interaction on a third party website or service, including any websites or services that may have a link on our website, are subject to that third party's own rules and guidelines. In addition, you agree that we are not responsible and have no control over third parties who authorize you to access your user content.</p>
            
            <br><h2>5. Changes to our privacy policy</h2><br>

            <p>The "Agecheck app" may change or update this data protection guideline from time to time, so you should check it regularly. We may be able to provide you with additional forms of notification of changes or updates as the circumstances allow. If you continue to use the "Agecheck app" or the service after changing this data protection guideline, you agree to the change.</p>
            
            <br><h2>6. Contact</h2><br>

            <p>If you have any questions or concerns about this privacy policy, please contact our support at contact@privately.eu.</p>

            <p>This data protection guideline and our collection and use of your data in accordance with this data protection guideline are subject to the substantive laws applicable in the canton of Vaud, Switzerland, and will be interpreted in accordance with them.</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- </fade-transition> -->
</template>

<script>
import { FadeTransition, SlideYDownTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      show: true
    };
  },
  components: {
    FadeTransition,
    SlideYDownTransition,
  },
  computed: {
    ...mapGetters("common", {
      pageElements: "pageElements"
    }),
  },
  mounted() {}
};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
